import React, {
  cloneElement,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { makeStyles } from '@mui/styles';

import { PubSub } from '../../../../utils/eventUtils';
import { TableContext } from '../base/context.table';

export function withExpandableRow(Row: any) {
  const C = ({ classes = {}, ...props }) => {
    const [expanded, setExpanded] = useState(false);
    // @ts-expect-error TS(2339): Property 'childOverrides' does not exist on type '... Remove this comment to see the full error message
    const { childOverrides } = useContext(TableContext);
    const rowClasses = useRowStyles();

    useEffect(() => {
      const sub = PubSub.subscribe('table-row:expanded', (rowId: any) => {
        if (expanded && rowId !== props.row.id) {
          // @ts-expect-error TS(2345): Argument of type 'void' is not assignable to param... Remove this comment to see the full error message
          setTimeout(setExpanded(false), 300);
        }
      });

      return () => {
        sub.remove();
      };
    }, [expanded, props.row.id]);

    const expandRow = useCallback(
      (event: any) => {
        if (
          event.target.matches &&
          event.target.closest &&
          !event.target.matches('td') &&
          !event.target.matches('.expand-icon') &&
          !event.target.closest('.expand-icon')
        ) {
          return;
        }

        if (!expanded) {
          PubSub.publish('table-row:expanded', props.row.id);
        } else {
          PubSub.publish('table-row:collapsed', props.row.id);
        }

        setExpanded(!expanded);
      },
      [expanded, props.row.id]
    );

    if (!childOverrides.ExpandableRow) {
      return <Row {...props} />;
    }

    return (
      <>
        <Row
          {...props}
          // @ts-expect-error TS(2339): Property 'withHover' does not exist on type '{}'.
          className={[classes.withHover, rowClasses.root]}
          onClick={expandRow}
          expanded={expanded}
        />
        {cloneElement(childOverrides.ExpandableRow, {
          expanded,
          classes,
          ...props,
        })}
      </>
    );
  };

  C.displayName = `withExpandableRow(${Row.displayName || Row.name})`;
  C.wrappedComponent = Row;

  return hoistNonReactStatics(C, Row);
}

const useRowStyles = makeStyles({
  root: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});
